import { API } from "../config/api"

const TOKEN_KEY = "invi_token"

function authHeaders(): HeadersInit {
  const token = localStorage.getItem(TOKEN_KEY)
  return {
    "Content-Type": "application/json",
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  }
}

export async function getPreferences(): Promise<Record<string, string>> {
  const resp = await fetch(`${API.baseUrl}${API.endpoints.preferences}`, {
    headers: authHeaders(),
  })
  if (!resp.ok) return {}
  return resp.json()
}

export async function updatePreference(
  key: string,
  value: string
): Promise<void> {
  await fetch(
    `${API.baseUrl}${API.endpoints.preferences}/${encodeURIComponent(key)}`,
    {
      method: "PUT",
      headers: authHeaders(),
      body: JSON.stringify({ value }),
    }
  )
}
